import mexicanLion from "./mexican-lion.png";

export const LionImage = () => {
  return (
    <div className="col-12 col-md-6 order-last order-md-first">
      <img className="img-fluid" src={mexicanLion} alt="liontravelers NFT" />
    </div>
  );
};
